import { M_REMEMBER_ACC } from './../../models/M_REMEMBER_ACC';

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Database } from '../database';


/*
  Generated class for the BllSettings provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BllRememberAcc extends Database {

  constructor() {
    super("M_REMEMBER_ACC")
  }

}



// WEBPACK FOOTER //
// ./src/providers/bll/bll-remember-acc.ts